<template>
	<v-dialog
		v-model="visible"
		max-width="500"
		persistent
	>
		<v-alert
			class="mb-0 px-8"
			border="top"
			colored-border
			:color="`#00AAFD`"
		>
			<div class="title-text">{{ title_text }}</div>
			<v-alert class="mx-0 mt-0" type="error" v-if="error_msg.length !== 0">
				{{ error_msg }}
			</v-alert>
			<div v-if="isForward || isFinance" class="dialog-content">
				<div class="user-selected-content">
					<div class="content-text-title mb-2">Select user</div>
					<v-tooltip attach left v-if="$vuetify.breakpoint.mdAndUp" max-width="calc(55%)" z-index="11">
						<template v-slot:activator="{ on, attrs }">
							<div v-bind="attrs" v-on="on">
								<InfoOutline width="14" height="14" color="#DADADA"/>
							</div>
						</template>
						<span>You can forward this claim to users who have the privilege of approving and editing claims.</span>
					</v-tooltip>
				</div>
				<v-combobox
					v-model="select"
					:items="items"
					item-text="display_name"
					prepend-inner-icon="search"
					outlined
					dense
					clearable
					:color="color"
				></v-combobox>
				<div class="content-text-title mb-2">Reason</div>
				<v-textarea
					outlined
					hide-details
					v-model="value"
					:color="color"
				></v-textarea>
				<div class="required-text">required</div>
			</div>
			<div v-else class="dialog-content">
				<v-textarea
					outlined
					hide-details
					v-model="value"
					:color="color"
				></v-textarea>
				<div class="required-text">required</div>
				<div class="content-text">Send to 
					<span class="content-name" v-for="(name, index) in sendToName" :key="index">
						{{ name }}
						<span v-if="(index + 1) !== sendToName.length">, </span>
					</span>
				</div>
			</div>
			<div class="button">
				<v-btn outlined class="button-cancel" @click="$emit('cancel')">{{ cancel_button }}</v-btn>
				<v-btn 
					v-if="isForward || isFinance"
					width="88" 
					depressed 
					:color="value.length > 0 && select? '#00AAFD': 'rgba(25, 42, 62, 0.15)'" 
					class="ml-2 white--text button-submit" 
					@click="$emit('submit', { approval_by: select, reason: value})">
					{{ confirm_button }}
				</v-btn>
				<v-btn 
					v-else
					width="88" 
					depressed 
					:color="value.length > 0 ? '#00AAFD': 'rgba(25, 42, 62, 0.15)'" 
					class="ml-2 white--text" 
					@click="$emit('ok', value)">
					{{ confirm_button }}
				</v-btn>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
import InfoOutline from "@/components/icons/info_outline";
const APPROVE_PRIVILEGE = 'Secap';
const EDIT_PRIVILEGE = 'Secapa';
const ABOOK_TYPES = 3; /* abook_types=3, employees only */

export default {
	name: 'ApprovalDialogMoreInfo',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: ""
		},
		title_text: {
			type: String,
			default: ''
		},
		confirm_button: {
			type: String,
			default: 'OK'
		},
		cancel_button: {
			type: String,
			default: 'Cancel'
		},
		type: {
			/*  info: blue, error: red, warning: yellow */
			type: String,
			default: 'info'
		},
		isForward: {
			type: Boolean,
			default: false
		},
		isFinance: {
			type: Boolean,
			default: false
		},
		suppliers: {
			type: Array,
			default: () => []
		},
		userID: {
			type: Number,
			default: null
		}
	},
	components: {
		InfoOutline
	},
	data() {
		return {
			value: '',
			select: null,
			error_msg: '',
			items: []
		}
	},
	async created() {
		if (this.isForward) {
			this.load_app_employees();
		}

		if (this.isFinance) {
			await this.load_app_gl_approval();
			await this.load_app_gl_edit();
		}
	},
	computed: {
		sendToName() {
			const supplier_list = this._unique(this.suppliers);
			return supplier_list.map(s => { return s.display_name});
		}
	},
	methods: {
		load_app_employees() {
			const params = [];
			params.push("abook_types=" + ABOOK_TYPES);
			params.push("has_privilege=" + APPROVE_PRIVILEGE);

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					const { status, data, reason} = d.data;

					if (status == "OK") {
						const filter_arr = data.filter(d => { return d.id !== this.userID})
						this.items = filter_arr;						
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		async load_app_gl_edit() {
			const params = [];
			params.push("abook_types=" + ABOOK_TYPES);
			params.push("has_privilege=" + EDIT_PRIVILEGE);

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					const { status, data, reason} = d.data;

					if (status == "OK") {
						const filter_arr = data.filter(d => { return d.id !== this.userID})

						if (this.items.length === 0) {
							this.items = filter_arr;
						} else {
							const existed_user_id_arr = this.items.map(item => {return item.id});
							filter_arr.forEach(d => {
								if (!existed_user_id_arr.includes(d.id)) {
									this.items.push(d);
								}
							})
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		async load_app_gl_approval() {
			const params = [];
			params.push("abook_types=" + ABOOK_TYPES);
			params.push("has_privilege=" + APPROVE_PRIVILEGE);

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(d => {
					const { status, data, reason} = d.data;

					if (status == "OK") {
						const filter_arr = data.filter(d => { return d.id !== this.userID})

						if (this.items.length === 0) {
							this.items = filter_arr;
						} else {
							const existed_user_id_arr = this.items.map(item => {return item.id});
							filter_arr.forEach(d => {
								if (!existed_user_id_arr.includes(d.id)) {
									this.items.push(d);
								}
							})
						}					
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_unique(arr) {
			const obj = {};
			arr.forEach(element => {
				obj[`${element.id}`] = element;
			});
			
			const result = Object.values(obj);
			return result;
		}
	}

}
</script>
<style lang="scss" scoped>
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.dialog-content {
	display: flex;
	flex-flow: column nowrap;
	margin: 20px 0;
}
.user-selected-content {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}
.content-text-title {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
	opacity: 0.87;
}
.content-text {
  font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	color: #192A3E;
}
.content-name {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: #192A3E;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.button-cancel {
	text-transform: none;
	color: rgba(25, 42, 62, 0.7);
}
.button-submit {
	text-transform: none;
}
.required-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;
	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
</style>